import type React from 'react';

import ElectricalServicesRoundedIcon from '@mui/icons-material/ElectricalServicesRounded';
import { Box, useTheme } from '@mui/material';
import { Handle, Position } from '@xyflow/react';

export default function EntryNode(): React.ReactElement {
  const theme = useTheme();
  const radius = theme.shape.borderRadius as string;

  return (
    <>
      <Box
        sx={{
          display: 'inline-flex',
          position: 'relative',
          backgroundColor: theme.palette.dialplan.entry,
          borderRadius: `${radius} calc(${radius} * 6) calc(${radius} * 6) ${radius}`,
          padding: '10px',
        }}
      >
        <ElectricalServicesRoundedIcon
          htmlColor={theme.palette.chip.red.close}
          sx={{
            width: 40,
            height: 40,
          }}
        />
      </Box>
      <Handle type='source' position={Position.Right} id='entry' />
    </>
  );
}
